import EstimateStatus from "@/usecases/orders/estimate-status";

const locale = {
  jp: {
    [EstimateStatus.Expected]: "見込み",
    [EstimateStatus.CreatedNew]: "見積中",
    [EstimateStatus.QuotedNew]: "見積提出",
    [EstimateStatus.Success]: "受注",
    [EstimateStatus.Failure]: "失注"
  }
};

export default {
  toJp(key: string): string {
    return locale.jp[key] || "";
  }
};
